/* global BigInt */
export const MODEL_PRECISION_KEY_V113 = 'alfredapi.model.full_precision.v113';

export function catalogPrecisionPreferenceV113(storage) {
  try {
    return storage.getItem(MODEL_PRECISION_KEY_V113) === 'true';
  } catch {
    return false;
  }
}

// Presentation only: round the decimal string without converting it to a float.
// Keep the original quote intact for full precision and for billing consumers.
export function catalogDecimalV113(value, fullPrecision = false) {
  const raw = String(value ?? '').trim();
  const match = /^(\d+)(?:\.(\d+))?$/.exec(raw);
  if (!match) return '-';
  if (fullPrecision) return raw;
  const fraction = match[2] || '';
  let scaled = BigInt(match[1] + fraction.slice(0, 4).padEnd(4, '0'));
  if (fraction.length > 4 && fraction[4] >= '5') scaled += BigInt(1);
  const digits = scaled.toString().padStart(5, '0');
  return `${digits.slice(0, -4)}.${digits.slice(-4)}`;
}

export function catalogPriceV113(value, fullPrecision = false) {
  const formatted = catalogDecimalV113(value, fullPrecision);
  return formatted === '-' ? '-' : `$${formatted}`;
}

export function catalogDisplayTextV113(language) {
  return language?.startsWith('zh')
    ? {
        precision: '精确显示',
        newest: '新到旧',
        oldest: '旧到新',
        name: '名称 A–Z',
        provider: '按厂商',
        capability: '按能力（高到低）',
        intelligence: 'AA 智能指数',
        unknown: '暂无评测',
        source: 'Artificial Analysis · OpenRouter',
        updated: '数据更新',
        modelDate: '型号日期',
        listedDate: 'OpenRouter 收录日期',
        unknownDate: '日期未知',
        stale: '历史评测',
      }
    : {
        precision: 'Full precision',
        newest: 'Newest first',
        oldest: 'Oldest first',
        name: 'Name A–Z',
        provider: 'Provider',
        capability: 'Capability (high to low)',
        intelligence: 'AA Intelligence Index',
        unknown: 'Not evaluated',
        source: 'Artificial Analysis · OpenRouter',
        updated: 'Updated',
        modelDate: 'Model version date',
        listedDate: 'OpenRouter listed',
        unknownDate: 'Date unknown',
        stale: 'Historical evaluation',
      };
}
